module.exports = __webpack_public_path__ + "static/media/computer_science.787df50e.png";